import { gql } from 'apollo-angular';

const FETCH_VOTE_TYPES = gql`
  query fetchVoteTypes {
    committeeVoteTypes {
      id
      name
    }
  }
`;
const FETCH_VOTES_FOR_PROJECT = gql`
  fragment CommitteeVoteArgs on CommitteeVote {
    id
    status
    is_proxy
    milestone {
      id
    }
    committeeVoteType {
      id
      name
    }
  }
  query fetchCommitteeVotes($input: CommitteeVoteSearch) {
    committeeVotes(input: $input) {
      ...CommitteeVoteArgs
    }
  }
`;
const CREATE_VOTE = gql`
  mutation createCommitteeVote($input: CommitteeVoteInput) {
    vote: createCommitteeVote(input: $input) {
      id
      status
      committeeVoteType {
        id
        name
      }
      user {
        person {
          name
        }
      }
      project_id
      milestone {
        id
      }
      milestone_id
      created
      modified
    }
  }
`;
const UPDATE_VOTE = gql`
  mutation updateCommitteeVote($id: ID!, $input: CommitteeVoteInput) {
    vote: updateCommitteeVote(id: $id, input: $input) {
      status
      user {
        person {
          name
        }
      }
      modified
    }
  }
`;
export default {
  FETCH_VOTE_TYPES,
  FETCH_VOTES_FOR_PROJECT,
  CREATE_VOTE,
  UPDATE_VOTE,
};
